import React, { useContext } from "react";
import { ModalProductPreviewStyled } from "./ModalProductPreviewStyled";
import Typography from "../../../../UI/Typography/Typography";
import { TYPOGRAPHY_TYPE } from "../../../../entities/Typography";
import { useSelector } from "react-redux";
import { getModalData } from "../../slice/selectors";
import { ModalContentListInterface } from "../../../../entities/Modal";
import { getValueForKey } from "../../../../context/translationsUtils";
import { TranslationContextInterface } from "../../../../entities/Language";
import { TranslationContext } from "../../../../context/TranslationContext";
import { transformArrayToString } from "../../../../utils/product";
import ImageComponent from "../../../../UI/ImageComponent";
import { useAppDispatch } from "../../../../store/store";
import Button from "../../../../UI/Button";
import { onCloseModal } from "../../slice/ModalSlice";
import { CustomAsyncSelectResultType } from "../../../../entities/CustomSelect";
import { useNavigate } from "react-router-dom";
import {
  getCombinedCondimentsIds,
  getSelectedCondimentsIds,
} from "../../../Condiment/selectors";

import {
  setCondiment,
  toggleCondiment,
} from "../../../Condiment/CondimentSlice";
import { CondimentService } from "../../../../services/CondimentService";

const ModalProductPreview: React.FC = () => {
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);
  const dispatch = useAppDispatch();
  const { content } = useSelector(getModalData);
  const navigate = useNavigate();
  const selectedCondimentIds = useSelector(getSelectedCondimentsIds);
  const combinedCondimentIds = useSelector(getCombinedCondimentsIds);
  const {
    id,
    name,
    image = "",
    description = "",
    botanicalOrigins = [],
    botanicalFamilies = [],
    recommendation = "",
    latinNames = [],
    history = "",
    condiments = [],
    categories = [],
    type,
  } = content;

  const modalContentList: ModalContentListInterface[] = [
    {
      label: getValueForKey(
        translations,
        "taste_harmony.additional_information_hint",
      ),
      content: description,
    },
    {
      label: getValueForKey(translations, "taste_harmony.latin_names_hint"),
      content: transformArrayToString(latinNames),
    },
    {
      label: getValueForKey(
        translations,
        "taste_harmony.botanical_origin_hint",
      ),
      content: transformArrayToString(botanicalOrigins),
    },
    {
      label: getValueForKey(
        translations,
        "taste_harmony.botanical_families_hint",
      ),
      content: transformArrayToString(botanicalFamilies),
    },
    {
      label: getValueForKey(translations, "taste_harmony.spice_history_hint"),
      content: history,
    },
    {
      label: getValueForKey(translations, "taste_harmony.dys_reccomendation"),
      content: recommendation,
    },
    {
      label: getValueForKey(translations, "nav_bar.categoryCondiments"),
      content: transformArrayToString(categories),
    },
    {
      label: getValueForKey(translations, "edit_mix.ingredients"),
      content: transformArrayToString(condiments),
    },
  ];
  const handleContinue = async () => {
    if (type === CustomAsyncSelectResultType.MIX && id) {
      navigate(`/mixes/${id}`);
      dispatch(onCloseModal());
    }
    if (type === CustomAsyncSelectResultType.CONDIMENT && id) {
      if (selectedCondimentIds.includes(id)) {
        dispatch(onCloseModal());
        return;
      }
      if (combinedCondimentIds.includes(id)) {
        dispatch(toggleCondiment({ id }));
        dispatch(onCloseModal());
        return;
      }

      const missedCondiment = await CondimentService.getCondiment(id);
      dispatch(setCondiment(missedCondiment));
      dispatch(onCloseModal());
    }
  };
  return (
    <ModalProductPreviewStyled>
      <div className="modal-product__preview">
        <div className="modal-product__image">
          <ImageComponent url={image} name={name} />
        </div>

        <div className="modal-product__items">
          {modalContentList.map((item, index: number) => {
            if (
              !item.content ||
              item.content === "" ||
              item.content.length === 0
            ) {
              return false;
            }
            return (
              <div className="modal-product__item" key={index}>
                <Typography type={TYPOGRAPHY_TYPE.BOLD}>
                  {item.label}
                </Typography>
                <Typography type={TYPOGRAPHY_TYPE.REGULAR}>
                  {item.content}
                </Typography>
              </div>
            );
          })}
        </div>
      </div>
      {type && (
        <div className="modal-product__actions">
          <Button
            className="red"
            onClick={() => dispatch(onCloseModal())}
            name={getValueForKey(
              translations,
              "nav_bar.nav_card_cancel_button",
            )}
          />
          <Button
            className="green"
            name={getValueForKey(
              translations,
              "nav_bar.nav_card_continue_button",
            )}
            onClick={() => handleContinue()}
          />
        </div>
      )}
    </ModalProductPreviewStyled>
  );
};

export default ModalProductPreview;
